module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-sidenav', {
    ref: "layerNav",
    staticClass: "md-left"
  }, [_c('md-toolbar', {
    staticClass: "md-dense main-toolbar"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Layers")])], 1), _vm._v(" "), _c('layer-list', {
    attrs: {
      "project": _vm.project,
      "layers": _vm.layers
    },
    on: {
      "showLayer": _vm.showLayer,
      "hideLayer": _vm.hideLayer
    }
  }), _vm._v(" "), (_vm.validLayers.length > 0) ? _c('layer-picker', {
    attrs: {
      "layers": _vm.validLayers,
      "currentLayer": _vm.currentLayer
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit) ? _c('layer-new', {
    attrs: {
      "project": _vm.project
    },
    on: {
      "showLayer": _vm.showLayer,
      "addLayer": _vm.addLayer
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-019034f4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/layers/nav.vue
// module id = 632
// module chunks = 2